import { FC } from "react"
import classNames from "classnames"
import { Icon, IconColor } from "@/components/shared/Icon"
import "./index.scss"

interface GradientIndicatorProps {
   value: number
   className?: string
}

const GradientIndicator: FC<GradientIndicatorProps> = ({
   value,
   className,
}) => {
   const clampedValue = Math.max(0, Math.min(100, value))
   return (
      <div className={classNames("gradient-indicator", className)}>
         <Icon
            name="triangleIndicator"
            className="gradient-indicator__triangle"
            color={IconColor.HONOLULU_BLUE}
            width="18"
            height="15"
            style={{ left: `calc(${clampedValue}% - 9px)` }}
         />
         <div className="gradient-indicator__gradient-bar" />
      </div>
   )
}

export default GradientIndicator
